<nz-modal
   nzWrapClassName="ncx-modal"
   [(nzVisible)]="addLabelsVisible"
   [nzContent]="modalContent"
   [nzFooter]="modalFooter"
   (nzOnCancel)="handleCancel()"
   [nzMaskClosable]="false">
   <ng-template #modalContent>
      <div [attr.data-component]="'@modals/add-labels'">
         <p class="header">{{ isNewLabel ? 'Add New' : 'Edit' }} Topic</p>

         <div class="body">
            <ng-container>
               <form
                  [formGroup]="isNewLabel ? sampleForm : editForm"
                  nz-form
                  nzLayout="vertical"
                  (ngSubmit)="submitForm()">
                  <nz-form-item>
                     <nz-form-label
                        nzRequired
                        nzLabelWrap="true">
                        {{ isNewLabel ? 'Add' : '' }} Topic Name
                     </nz-form-label>
                     <nz-form-control nzErrorTip="Topic Name is required">
                        <textarea
                           nz-input
                           formControlName="topicName"
                           nzAutosize
                           placeholder="Type topic name here"></textarea>
                     </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                     <nz-form-label
                        nzRequired
                        nzLabelWrap="true">
                        {{ isNewLabel ? 'Add' : '' }} Topic ID Code
                     </nz-form-label>
                     <nz-form-control nzErrorTip="Valid Topic Code is required">
                        <input
                           *ngIf="isNewLabel"
                           nz-input
                           nzRequired
                           maxlength="2"
                           pattern="[a-zA-Z]{2}"
                           formControlName="topicCode"
                           placeholder="Add topic code initials i.e: CD" />
                        <input
                           *ngIf="!isNewLabel"
                           nz-input
                           nzRequired
                           [disabled]="true"
                           [value]="existingCode" />
                     </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                     <nz-form-label nzLabelWrap="true">{{ isNewLabel ? 'Add' : '' }} Topic Notes</nz-form-label>
                     <nz-form-control>
                        <app-rteditor
                           [rteHeight]="100"
                           [input]="'topicNotes'"
                           [isEmitted]="isEmitted"
                           [rteValue]="isNewLabel ? rteData : rtEditData"
                           (rteUpdated)="getRTEData($event)"
                           (rtePasteContent)="updateRTEData($event)"
                           (rteContentChanged)="updateRTEData($event)"
                           (rteEdited)="updateRTEData($event)"></app-rteditor>
                        <!-- <textarea nz-input formControlName="topicNotes" ></textarea> -->
                     </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                     <span>
                        <span class="mr-8">Active</span>
                        <nz-switch formControlName="topicActiveState"></nz-switch>
                     </span>
                  </nz-form-item>
               </form>
            </ng-container>
         </div>
      </div>
   </ng-template>
   <ng-template #modalFooter>
      <button
         nz-button
         nzType="default"
         class="footer-btn"
         (click)="handleCancel()">
         Cancel
      </button>
      <button
         *ngIf="!isNewLabel"
         nz-button
         nzType="primary"
         class="footer-btn"
         (click)="handleOk()">
         Save Topic
      </button>
      <button
         *ngIf="isNewLabel"
         nz-button
         nzType="primary"
         class="footer-btn"
         (click)="submitForm()">
         Add Topic
      </button>
   </ng-template>
</nz-modal>
